// CartContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [tempCartId, setTempCartId] = useState(null);

  useEffect(() => {
    const storedCartId = localStorage.getItem("tempCartId");
    const storedCart = localStorage.getItem("cartItems");

    if (!storedCartId) {
      const newId = uuidv4();
      localStorage.setItem("tempCartId", newId);
      setTempCartId(newId);
    } else {
      setTempCartId(storedCartId);
    }

    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const addToCart = (product) => {
    const existing = cartItems.find((item) => item.id === product.id);

    if (existing) {
      toast.warning("Service already in the cart");
      return;
    }

    setCartItems((prev) => [...prev, { ...product, quantity: 1 }]);
    toast.success("Service added to cart");
  };

  const removeFromCart = (productId) => {
    setCartItems((prev) => prev.filter((item) => item.id !== productId));
    toast.info("Service removed from cart");
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cartItems");
  };

  const handleUserLogin = () => {
    localStorage.removeItem("tempCartId");
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        handleUserLogin,
        tempCartId,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
